// @ts-nocheck
/* eslint-disable */
"use client";

import { Heading } from "politicamente-informados-ds";
import classNames from "classnames";
import getBlockStyles from "@/lib/wordpress/blocks/getBlockStyles";

export type IBlockHeading = {
  attrs: {
    anchor?: string;
    content?: string;
    level?: number;
    fontSize?: string;
    maxWidth?: string;
    textAlign?: string;
    textColor?: string;
    backgroundColor?: string;
    className?: string;
    style?: Record<string, unknown>;
    animation?: string;
  };
};

export default function BlockHeading({ attrs }: IBlockHeading) {
  const {
    anchor,
    content,
    level,
    fontSize,
    maxWidth,
    textAlign,
    textColor,
    backgroundColor,
    className,
    style,
    animation,
  } = attrs || {};
  const headingStyle = getBlockStyles({
    textColor,
    backgroundColor,
    style,
    maxWidth,
  });

  return (
    <Heading
      id={anchor || undefined}
      tag={level ? `h${level}` : "h1"}
      size={fontSize ? fontSize : level ? `h${level}` : "h3"}
      className={classNames(
        className,
        animation && `elements_animated ${animation}`
      )}
      style={{
        ...headingStyle,
        textAlign: textAlign && textAlign,
      }}
      dangerouslySetInnerHTML={{ __html: content }}
    ></Heading>
  );
}
